export enum EVIDENCE_TABS {
  EVIDENCE = 'Evidence',
  EXCLUDED = 'Excluded',
  SOURCE = 'Source',
  PROPERTIES = 'Properties',
  CONTROLS = 'Linked Controls',
  CONTROL_SUGGESTIONS = 'Control Suggestions',
  REQUESTS = 'Requests',
}
